import { render, staticRenderFns } from "./creditLimitErrorList.vue?vue&type=template&id=204b7881"
import script from "./creditLimitErrorList.vue?vue&type=script&lang=js"
export * from "./creditLimitErrorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports